export const routesPath = {
    DEFAULT: '',
    COMMON: {
        HOME: '',
        DASHBOARD: 'dashboard',
        ERROR: '*',
        FORBIDDEN: '403-forbidden',
        INTERNALSERVER: 'internalserver'
    },
    AUTH: {
        LOGIN: 'login',
        REGISTER: 'signup',
        FORGOTPASSWORD: 'forgotpassword',
        ACTIVE_ACCOUNT: 'active_user'
    },
    STAFF: 'staff/*',
    TEACHERS: 'teachers/*',
    STUDENTS: 'students/*',
    COURSES_ADMIN: 'courses-mgr/*',
    COURSES_STUDENT: 'courses/*',
    PROGRAMS: 'programs/*',
    SERVICES: {
        LIST: 'services',
        DETAIL: 'service-details'
    },
    PROFILE: 'pageProfile',
    TOKENS: 'tokens',
    EVENTS: 'events'
};
